import { createRouter, createMemoryHistory, createWebHistory } from "vue-router";
import HomePage from "@/ui/admin/home/HomePage.vue";
import TestimonialHome from "@/ui/admin/testimonials/TestimonialHome.vue";
import SettingsHome from "@/ui/admin/settings/SettingsHome.vue";
import LoginPage from "@/ui/admin/settings/LoginPage.vue";
import authService from "@/core/services/AuthService";
import TestimonialsReview from "@/ui/admin/settings/review/TestimonialsReview.vue";
import OptionsHome from "@/ui/admin/settings/options/OptionsHome.vue";
import Player from "@/ui/site/player/Player.vue";
import NotFound from "@/ui/site/NotFound.vue";
import TeamSettings from "@/ui/admin/settings/team/TeamSettings.vue";

const currentPath = window.location.pathname;

const isPublic = currentPath.startsWith("/share");
const authUser = async (to, from, next) => {
    try {
        let token = authService.getToken();

        if (token) {
            await authService.authenticateWithToken(token);

            next();
            return;
        }

        const accessCode = authService.getAccessCode();

        if (accessCode) {
            await authService.authenticateWithCode(accessCode);
            window.history.replaceState({}, "", "");

            next({ query: {} });
            return;
        }

        if (!token && !accessCode && to.path != "/login") {
            next("/login");
            return;
        }

        next();
    } catch (error) {
        window.history.replaceState({}, "", window.location.pathname);
        authService.removeToken();
        next("/login");
    }
};

const routes = [
    { path: "/login", component: LoginPage },
    {
        path: "/",
        name: "home",
        component: HomePage,
        children: [
            { path: "/", name: "dashboard", component: TestimonialHome },
            {
                path: "/settings",
                component: SettingsHome,
                children: [
                    {
                        path: "review",
                        component: TestimonialsReview,
                    },
                    {
                        path: "options",
                        component: OptionsHome,
                    },
                    {
                        path: "teams",
                        component: TeamSettings,
                    },
                ],
            },
        ],
    },
];

const publicRoutes = [
    {
        path: "/share/:shareId",
        name: "publicPlayer",
        component: Player,
    },
    { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

// Create router instance
const mainRouter = createRouter({
    history: createWebHistory(),
    routes: isPublic ? publicRoutes : routes, // Set up the routes
});

if (!isPublic) {
    mainRouter.beforeEach(authUser);
}

export default mainRouter;
